// Actions

export const OPEN = 'Cart/elements/Comment/OPEN';
export const CLOSE = 'Cart/elements/Comment/CLOSE';
export const TOGGLE = 'Cart/elements/Comment/TOGGLE';

// Action creators

export function open() {
  return { type: OPEN };
}

export function close() {
  return { type: CLOSE };
}

export function toggle() {
  return { type: TOGGLE };
}
